

/* eslint-disable vue/attributes-order */
import { Component, PropSync, Ref, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import StatusMixin from '@/shared/mixins/status.mixin';
import { messageSent } from '@/shared/constants/notifications';
import { Loading } from '@/modules/auth/store/auth.service';
import Table from '@/components/table/Table.vue';
import { BookingStatus } from '@/app/dto/bookingDto';
import { tenantModule } from '@/store/modules/tenant/tenant.module';
import { IGuestDto } from '../../../app/models/tenant/IBookingDto';
import { IBookingDto } from '../../../app/entities/tenant/IBookingDto';
import { mapState } from 'vuex';
import BookingRow from '@/modules/booking/components/BookingRow.vue';
import BookingGuestInfo from '@/modules/booking/components/BookingGuestInfo.vue';
import Guest from '../../../app/entities/tenant/guest.dto';
import { guestModule } from '@/store/modules/guest.module';

interface rowData {
  booking: IBookingDto;
  guest: IGuestDto;
  minor: boolean;
  parentObject: IGuestDto;
}

@Component({
  filters: {
    calcAge: (val: any) => {
      const arr = val.split(' ');
      const year = new Date().getFullYear();
      const age = year - arr[2];
      return age;
    },
  },
  components: {
    Table,
    BookingRow,
    BookingGuestInfo,
  },
  computed: {
    ...mapState('tenant', ['accommodations']),
  },
})
export default class BookingTable extends mixins(StatusMixin) {
  @PropSync('editBooking') editBookingSync: IBookingDto;

  @PropSync('bookings') bookingsSync!: any;

  accommodations!: any[];

  selected: [] = [];

  page = 1;

  perPage = 10;

  pages: number[] = [];

  @Ref('expand') expandable: any;

  selectedIndex: number | null = null;

  activeSync = false;

  currentSort = 'checkInDate';

  search = '';

  sortedBookigns = [];

  minorObj = { firstName: '', lastName: '' };

  searchedBookings = [];

  viewMoreData = {};

  currentSortDir = 'desc';

  @Watch('bookings')
  bookingHandler(): void {
    this.setPages();
  }
  @Watch('bookingsSync')
  syncHandler(): void {
    this.sortedBookigns = this.bookingsSync;
    this.sortedData();
  }

  @Watch('search')
  searchHandler(): void {
    if (this.search == '') {
      this.searchedBookings = [];
    } else {
      this.searchedBookings = this.sortedBookigns.filter((booking: { bookingReference: string }) => {
        return booking.bookingReference.toUpperCase().includes(this.search.toUpperCase());
      });
    }
  }

  filteredList() {
    return this.sortedBookigns.filter((booking: any) => {
      return booking.bookingReference.toUpperCase().includes(this.search.toUpperCase());
    });
  }
  sortPrimary(ref: any) {
    return this.bookingsSync[ref].guest.sort(function (x: { isPrimary: boolean }, y: { isPrimary: boolean }) {
      return x.isPrimary == true ? -1 : y.isPrimary == true ? 1 : 0;
    });
  }
  mounted() {
    this.search = '';
    this.searchedBookings = [];
    this.sortedBookigns = this.bookingsSync;
    if (this.bookingsSync) this.setPages();
    this.sortedData();
  }

  getGuestImageUrl(guest: any) {
    return (
      guest.user?.imageUrl ??
      'data:image/jpeg;base64,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'
    );
  }

  @Loading
  async handleSelected(ref: any, booking: IBookingDto) {
    if (this.selectedIndex === ref) {
      this.selectedIndex = null;
    } else {
      await guestModule.findGuestBooking(booking.id);
      this.selectedIndex = ref;
      this.sortPrimary(ref);
    }
  }

  @Loading
  async startCheckin(guest: IGuestDto): Promise<void> {
    const payload = {
      guestInfo: guest,
      profile: guest.profile,
    };
    payload.guestInfo.status = BookingStatus.PENDING;
    await this.$store.dispatch('guest/startCheckIn', payload);

    this.$emitter.emit('upload', messageSent('Checkin invitation'));
  }

  completeCheckin(index: number): void {
    const guest = this.bookingsSync.guest[index];

    guest.status = BookingStatus.CHECKEDIN;
  }

  setPages(): void {
    const numberOfPages = Math.ceil(this.bookingsSync.length / this.perPage);
    for (let index = 1; index <= numberOfPages; index += 1) {
      this.pages.push(index);
    }
  }

  setEditBooking(booking: IBookingDto) {
    // eslint-disable-next-line no-param-reassign
    booking.dates = {
      checkInDate: booking.checkInDate,
      checkOutDate: booking.checkOutDate,
    };
    this.editBookingSync = booking;
  }

  async sort(s: string) {
    if (s === this.currentSort) {
      this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
    }
    this.currentSort = s;
    this.sortedData();
  }
  sortedData() {
    this.selectedIndex = null;
    return this.sortedBookigns.sort((a: { [x: string]: number }, b: { [x: string]: number }) => {
      let modifier = 1;
      if (this.currentSortDir === 'asc') modifier = -1;
      if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
      if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
      return 0;
    });
  }

  viewMore({ booking, guest, minor, parentObject }: rowData): void {
    this.viewMoreData = {
      booking: booking,
      guest: guest,
      minor: minor,
      parent: parentObject,
    };
    this.activeSync = true;
  }

  calculateCheckedInGuests(guestArr: any) {
    let numberOfMinors = 0;
    guestArr.forEach((element: Guest) => {
      if (
        element.status === BookingStatus.PRECHECKEDIN ||
        element.status === BookingStatus.CHECKEDOUT ||
        (element.status === BookingStatus.CHECKEDIN && element.minor)
      ) {
        numberOfMinors += element.minor.length;
      }
    });
    return (
      guestArr.filter((val: Guest) => {
        return (
          val.status == BookingStatus.PRECHECKEDIN || val.status === BookingStatus.CHECKEDIN || val.status === BookingStatus.CHECKEDOUT
        );
      }).length + numberOfMinors
    );
  }
}
